import React, {useContext, useEffect} from "react";
import {Route, Routes} from "react-router";
import {ClassPacks} from "./ClassPacks/ClassPacks";
import {AddOrUpdateClassPack} from "./ClassPacks/AddOrUpdateClassPack";
import {ProviderProfileContext} from "../../../../ProviderProfileProvider";
import {useLocation} from "react-router-dom";
import {NavigateWithParams} from "../../../../util/NavUtils";
import {ClassTemplates} from "./ClassTemplates/ClassTemplates";
import {AddOrUpdateClassTemplate} from "./ClassTemplates/AddOrUpdateClassTemplate";
import {Services} from "./Services/Services";
import {AddOrUpdateService} from "./Services/AddOrUpdateService";

export const useCatalogTabs = () => {

  const {business} = useContext(ProviderProfileContext);
  const location = useLocation();

  const tabs = [];

  if (business?.businessSettings?.offersClasses) {
    tabs.push({
      label: 'Classes',
      link: '../classes',
      isSelected: location.pathname.startsWith('/home/catalog/classes'),
    });
  }

  if (business?.businessSettings?.offersAppointments) {
    tabs.push({
      label: 'Services',
      link: '../services',
      isSelected: location.pathname.startsWith('/home/catalog/services'),
    });
  }

  tabs.push({
    label: 'Packages',
    link: '../packages',
    isSelected: location.pathname.startsWith('/home/catalog/packages'),
  });

  return tabs;
}

export const CatalogRouter = () => {

  const {business} = useContext(ProviderProfileContext);

  useEffect(() => {

  }, []);

  return <div className={'NonScrollingToolPage'}>

    <Routes>
      {business?.businessSettings?.offersClasses && <>
        <Route path="/classes" element={<ClassTemplates/>}/>
        <Route path='/classes/add' element={<AddOrUpdateClassTemplate/>}/>
        <Route path='/classes/edit/:idParam' element={<AddOrUpdateClassTemplate/>}/>
      </>}
      
      {business?.businessSettings?.offersAppointments && <>
        <Route path="/services" element={<Services/>}/>
        <Route path='/services/add' element={<AddOrUpdateService/>}/>
        <Route path='/services/edit/:idParam' element={<AddOrUpdateService/>}/>
      </>}

      <Route path="/packages" element={<ClassPacks/>}/>
      <Route path="/packages/add" element={<AddOrUpdateClassPack/>}/>
      <Route path="/packages/edit/:idParam" element={<AddOrUpdateClassPack/>}/>

      <Route path="/" element={
        <NavigateWithParams to={business?.businessSettings?.offersClasses ? 'classes' : 'services'}/>}/>
    </Routes>
  </div>
}
